import { InstanceLink } from '@/components/routing';
import {
  SidebarContent,
  SidebarHeader,
  Sidebar as SidebarPrimitive,
  useSidebar,
} from '@/components/Sidebar';
import { ROUTES } from '@/router';

import { AppMenu } from '../AppMenu';
import { Logo } from '../Logo';

export type SidebarProps = Record<string, never>;

const Sidebar = () => {
  const { isMobile, setOpenMobile } = useSidebar();

  const handleMenuSelect = () => {
    if (isMobile) {
      setOpenMobile(false);
    }
  };

  return (
    <SidebarPrimitive data-testid="sidebar">
      <SidebarHeader className="gap-0 p-0">
        <InstanceLink to={ROUTES.dashboard.path}>
          <Logo />
        </InstanceLink>
      </SidebarHeader>
      <SidebarContent>
        <AppMenu onMenuSelect={handleMenuSelect} />
      </SidebarContent>
    </SidebarPrimitive>
  );
};

export default Sidebar;
